export class HeaderStyle {
  maxWidth = 'uk-container-expand uk-padding-remove';
  outsideContainer = 'header-absolute';
  boxShadow = '';

  static normalize(styles: Partial<HeaderStyle>): HeaderStyle {
    const pureStyles = new HeaderStyle();

    pureStyles.maxWidth = styles.maxWidth ?? pureStyles.maxWidth;
    pureStyles.outsideContainer = styles.outsideContainer ?? pureStyles.outsideContainer;
    pureStyles.boxShadow = styles.boxShadow ?? pureStyles.boxShadow;

    return pureStyles;
  }
}
